import { get } from './request'

export async function fetchMeetings({ language = 'hu' }) {
  const response = await get<any>(`/user/professional-requests?lng=${language}`)
  return response
}
